import { House, Info, Play, Settings } from 'lucide-preact'
import { text } from '#contract'
import { useClient } from '../app/client-context.ts'
import { useScreenStack } from '../app/screen-stack.ts'
import { useView } from '../app/use-view.ts'
import { Button } from '../components/button.tsx'
import { ScreenPanel } from '../components/screen-panel.tsx'
import { useT } from '../i18n/index.ts'
import styles from './pause-screen.module.css'

/**
 * Shown while the game is paused. Quitting goes back to the last save, so while there's play
 * since then the screen says it'll be lost.
 */
export function PauseScreen() {
  const t = useT()
  const client = useClient()
  const { push } = useScreenStack()
  const unsaved = useView((view) => view.saves.unsaved)

  return (
    <ScreenPanel
      title={t(text('pause.title'))}
      footer={
        <>
          <Button variant="ghost" icon={House} onClick={() => client?.quitToMenu()}>
            {t(text('pause.quit'))}
          </Button>
          <Button
            variant="ghost"
            icon={Settings}
            onClick={() => {
              push('settings')
            }}
          >
            {t(text('pause.settings'))}
          </Button>
          <Button
            variant="ghost"
            icon={Info}
            onClick={() => {
              push('credits')
            }}
          >
            {t(text('pause.credits'))}
          </Button>
          <Button icon={Play} autoFocus onClick={() => client?.resume()}>
            {t(text('pause.resume'))}
          </Button>
        </>
      }
    >
      {unsaved ? <p class={styles.unsaved}>{t(text('pause.unsaved'))}</p> : undefined}
    </ScreenPanel>
  )
}
